import { FontButton } from "../../../../molecules/buttons/FontButton";
import { FontSizeControlReact } from "../FontSizeControlReact";

export function FontButtonReact() {
  return (
    <FontButton>
      <FontSizeControlReact />
    </FontButton>
  );
}
